export const endpoints: any = {
    withAEM: {
        aelAEMContents: "/etc.clientlibs/hsbc/uaeapplicationv2/clientlibs/resources/json/ael.json",
        leadFormPage: "/content/hsbc/ae/en_ae/uaeapplicationv2/index/leadform/jcr:content.leadfo.json",
        accountConversionForm: "/content/hsbc/ae/en_ae/uaeapplicationv2/index/aramaxform/jcr:content.aramaxfo.json",
        poaForm: "/content/hsbc/ae/en_ae/uaeapplicationv2/index/poa/jcr:content.poa.json",
        taxInfoForm: "/content/hsbc/ae/en_ae/uaeapplicationv2/index/taxform/jcr:content.tax.json",
        fatcaForm: "/content/hsbc/ae/en_ae/uaeapplicationv2/index/fatca/jcr:content.fatca.json"
    },
    withoutAEM: {
        aelAEMContents: "/json/ael.json",
        leadFormPage: "/json/aem-lead-form.json",
        accountConversionForm: "/json/aem-account-conversion-form.json",
        poaForm: "/json/poa-form.json",
        taxInfoForm: "/json/tax-info-form.json",
        fatcaForm: "/json/fatca-form.json",
        documentList:"/json/docupload.json"

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/utitlity/endpoints.ts